import { differenceBetweenDates } from '../locale';
export function isMinor(birthday) {
    var difference = differenceBetweenDates({
        secondDate: birthday,
        unit: 'month',
    });
    return difference / 12 < 18;
}
